import React, {Fragment} from 'react'
import Tilt from 'react-parallax-tilt';
import { Link } from 'react-router-dom';
import BannerImg from '../../assets/img/hero/banner4.png'; // Doğru yol
const ThemeBannerThree = () => {
    return (
        <Fragment>
            <div
                className="theme-banner-three pt-30 pb-15 pt-lg-120 pb-lg-100 pt-md-50 pb-md-40">
                <img
                    className="banner-shape shape-one d-none d-sm-inline-block"
                    src="assets/img/shape/star-3b.svg"
                    alt="shape"/>
                <img
                    className="banner-shape shape-two d-none d-lg-inline-block"
                    src="assets/img/shape/star-4b.svg"
                    alt="shape"/>
                <img
                    className="banner-shape shape-three d-none d-sm-inline-block"
                    src="assets/img/shape/star-2.svg"
                    alt="shape"/>
                <img
                    className="banner-shape shape-four d-none d-md-inline-block "
                    src="assets/img/shape/star-4b.svg"
                    alt="shape"/>
                <img
                    className="banner-shape shape-five"
                    src="assets/img/shape/star-7c.svg"
                    alt="shape"/>
                <img
                    className="banner-shape shape-six d-none d-xl-inline-block"
                    src="assets/img/hero/hero-shape-3a.svg"
                    alt="shape"/>
                <img
                    className="banner-shape shape-seven d-none d-xl-inline-block"
                    src="assets/img/hero/hero-shape-3b.svg"
                    alt="shape"/>
                <div className="container">
                    <div className="row gx-4 gx-xxl-5 align-items-center">
                        <div className="col-xl-6 col-md-6">
                            <div className="theme__content__two text-md-start text-center mb-25">
                                <h4 className="hero-sub-title mb-25">Software Company</h4>
                                <h1 className="main-title-two">
                                Sharpen Your
                                    <br/>
                                    Focus On 
                                    <span> Cruxes</span>
                                </h1>
                                <Link className="theme_btn" to="/contact">Get Our Quote</Link>
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-6">
                            <Tilt>
                                <div className="hero-ilustration-wrapper mb-35">
                                    <img className='heroImg' src={BannerImg} alt="Banner"/>
                                </div>
                            </Tilt>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default ThemeBannerThree